// Mock data for Shiny-Cleaning replica

export const SITE = {
  name: 'Shiny-Cleaning',
  phone: '+31 570-238004',
  phoneHref: 'tel:+31570238004',
  email: 'info@shiny-cleaning.nl',
  location: 'Deventer, Nederland',
};

export const NAV = [
  { label: 'Home', to: '/' },
  { label: 'Diensten', to: '/diensten' },
  { label: 'Projecten', to: '/portfolio' },
  { label: 'Prijzen', to: '/prijzenlijst' },
  { label: 'Detailing aan huis', to: '/detailing-aan-huis' },
  { label: 'Over Ons', to: '/over' },
  { label: 'Contact', to: '/contact' },
];

export const HERO_STATS = [
  { value: '12+', label: 'Jaar ervaring' },
  { value: "2.400+", label: "Auto's behandeld" },
  { value: '3', label: 'Vaste detailers' },
  { value: 'Premium', label: 'Producten & coatings' },
];

export const SERVICES = [
  {
    slug: 'detailing',
    number: '01',
    title: 'Detailing',
    short: 'Showroom-staat, binnen \u00e9n buiten.',
    description: 'Volledige reiniging van binnen en buiten \u2014 handwas, decontaminatie, dieptereiniging van interieur en afwerking met een beschermlaag. Uw auto voelt weer nieuw.',
    suitableFor: ['Daily drivers die weer als nieuw moeten voelen', 'Auto\u2019s v\u00f3\u00f3r verkoop of inruil', 'Leaseauto\u2019s bij inlevering'],
    seoTitle: 'Complete autodetailing & interieurreiniging auto Deventer',
    seoDesc: 'Complete autodetailing in Deventer: grondige interieurreiniging, handwas en dieptereiniging binnen \u00e9n buiten. Vanaf \u20ac149 \u2014 ook als onderhoudsbehandeling aan huis beschikbaar. Vraag vrijblijvend een offerte aan.',
    benefits: ['Showroom-staat binnen \u00e9n buiten', 'Grondige interieurreiniging en dieptereiniging', 'Veilige wasmethode zonder nieuwe swirls', 'Ook als onderhoudsbehandeling aan huis beschikbaar'],
    expectation: 'Een volledig gereinigde, frisse en verzorgde auto. Zichtbaar vuil, stof en aanslag verdwijnen. Bij ingesleten vlekken of beschadigde lak adviseren wij vooraf eerlijk wat w\u00e9l en niet haalbaar is.',
    price: 'Vanaf \u20ac149',
    image: 'https://images.unsplash.com/photo-1708805282706-f44730b7e527?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  },
  {
    slug: 'glascoating',
    number: '02',
    title: 'Glascoating',
    short: 'Onzichtbaar pantser voor uw lak.',
    description: 'Langdurige bescherming tegen vuil, UV-straling en weersinvloeden. Water parelt eraf en de lak behoudt jarenlang zijn diepe glans.',
    suitableFor: ['Nieuwe auto\u2019s', 'Liefhebbersauto\u2019s', 'Auto\u2019s die makkelijker schoon moeten blijven'],
    seoTitle: 'Keramische coating (glascoating) Deventer',
    seoDesc: 'Keramische coating in Deventer voor langdurige bescherming en diepe glans. Water parelt af en de lak blijft makkelijker schoon. Vanaf \u20ac699 \u2014 uitgevoerd in onze professionele werkplaats.',
    benefits: ['Langdurige bescherming tegen vuil, UV en weer', 'Sterk water- en vuilafstotend effect', 'Diepe, natte glans', 'Lak blijft merkbaar makkelijker schoon'],
    expectation: 'Een keramische coating beschermt en verdiept de lak, maar is geen onverwoestbaar pantser: het voorkomt geen steenslag of diepe krassen. Voor het beste resultaat gaat vaak een lakcorrectie vooraf. Uitgevoerd in onze werkplaats in Deventer.',
    price: 'Vanaf \u20ac699',
    image: 'https://images.pexels.com/photos/94272/sports-car-pkw-auto-vehicle-94272.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  },
  {
    slug: 'ppf',
    number: '03',
    title: 'PPF \u2014 Paint Protection Film',
    short: 'Zelfherstellende film tegen steenslag.',
    description: 'Vrijwel onzichtbare hoogwaardige folie die uw lak beschermt tegen steenslag, krassen en insecten. Zelfhelend en volledig verwijderbaar.',
    suitableFor: ['Exclusieve of nieuwe voertuigen', 'Sportwagens en supercars', 'Motorkap, voorbumper en flanken'],
    price: 'Vanaf \u20ac1.299',
    image: 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=1600&q=85',
  },
  {
    slug: 'lakcorrectie',
    number: '04',
    title: 'Lakcorrectie',
    short: 'Krassen, swirls en holograms \u2014 weg.',
    description: 'Machinaal polijsten in \u00e9\u00e9n, twee of drie stappen. Wij verwijderen krassen, swirls en oxidatie en herstellen de originele diepte en glans van de lak.',
    suitableFor: ['Auto\u2019s met zichtbare krassen of swirls', 'Show cars en concours-voertuigen', 'V\u00f3\u00f3r het aanbrengen van een coating'],
    seoTitle: 'Auto polijsten & lakcorrectie Deventer',
    seoDesc: 'Professioneel auto polijsten en lakcorrectie in Deventer. Wij verwijderen krassen, swirls en oxidatie en herstellen de diepe glans. Vanaf \u20ac399 \u2014 uitgevoerd in onze professionele werkplaats.',
    benefits: ['Krassen, swirls en holograms zichtbaar verminderd', 'Diepe, egale en heldere glans hersteld', 'Machinaal polijsten in 1, 2 of 3 stappen', 'Ideale basis v\u00f3\u00f3r een keramische coating'],
    expectation: 'Lakcorrectie verbetert de lak aanzienlijk, maar niet elke kras is volledig weg te halen \u2014 diepe krassen tot in de basislaag blijven soms zichtbaar. Wij beoordelen uw lak vooraf en vertellen eerlijk welk resultaat haalbaar is. Deze behandeling voeren wij uit in onze werkplaats in Deventer.',
    price: 'Vanaf \u20ac399',
    image: 'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1600&q=85',
  },
  {
    slug: 'ramentinten',
    number: '05',
    title: 'Ramentinten',
    short: 'Privacy, koelte en stijl in \u00e9\u00e9n laag.',
    description: 'Professionele blindering van uw ramen met hoogwaardige folie \u2014 UV-werend, warmte-reflecterend en volgens Nederlandse wetgeving.',
    suitableFor: ['Gezinsauto\u2019s (bescherming achterin)', 'SUV\u2019s en bedrijfsauto\u2019s', 'Auto\u2019s waar privacy gewenst is'],
    price: 'Vanaf \u20ac249',
    image: 'https://images.unsplash.com/photo-1568605117036-5fe5e7bab0b7?w=1600&q=85',
  },
  {
    slug: 'auto-wrappen',
    number: '06',
    title: 'Auto Wrappen',
    short: 'Een nieuwe kleur. Geen blijvende lak.',
    description: 'Verander de kleur of finish van uw auto volledig \u2014 mat, glans, satijn of chrome \u2014 zonder aan uw originele lak te komen. Reversibel, professioneel aangebracht.',
    suitableFor: ['Nieuwe look zonder herspuiten', 'Bedrijfsvoertuigen met huisstijl', 'Bescherming van originele lak'],
    price: 'Vanaf \u20ac2.499',
    image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=1600&q=85',
  },
  {
    slug: 'transport',
    number: '07',
    title: 'Exclusief gesloten transport',
    short: 'Discreet vervoer voor uw exclusieve voertuig.',
    description: 'Gesloten transport voor supercars, oldtimers en waardevolle projecten. Volledig verzekerd, discreet en met de zorg die uw voertuig verdient.',
    suitableFor: ['Supercars en klassiekers', 'Show cars en concours-transport', 'Voertuigen bij aankoop of levering'],
    price: 'Op aanvraag',
    image: 'https://images.unsplash.com/photo-1558981806-ec527fa84c39?w=1600&q=85',
  },
];

export const VALUE_PROPS = [
  'Garantie op werk',
  'Premium producten',
  'Gecertificeerde detailers',
  'Op afspraak open',
];

export const VALUES = [
  {
    number: '01',
    title: 'Vakmanschap',
    text: 'Elke handeling met aandacht en kennis uitgevoerd.',
  },
  {
    number: '02',
    title: 'Precisie',
    text: 'Geen detail te klein. Geen oppervlak ongezien.',
  },
  {
    number: '03',
    title: 'Betrouwbaarheid',
    text: 'Korte lijnen, eerlijke communicatie en op tijd.',
  },
];

export const GOOGLE_REVIEWS = {
  rating: '5.0',
  count: 24,
  profileUrl: 'https://www.google.com/maps/search/?api=1&query=Shiny-Cleaning+Deventer',
  items: [
    {
      name: 'Mirella Spanjer',
      vehicle: 'Google review',
      rating: 5,
      text: 'Deze mannen weten goed wat ze doen. Er is echt vakwerk geleverd en mijn auto heeft er nog nooit zo blinkend bij gestaan. Ik kom zeker weer, toppers!',
    },
    {
      name: 'Eline Wessels',
      vehicle: 'Google review',
      rating: 5,
      text: 'Heel tevreden! Super behulpzaam, denkt echt met je mee en geeft eerlijk advies. Het werk is strak en netjes gedaan, met oog voor de kleinste details. Absoluut een aanrader!',
    },
    {
      name: 'Alex Hissink',
      vehicle: 'Google review',
      rating: 5,
      text: 'Mike heeft mijn BMW volledig onderhanden genomen. Alle waskrassen zijn eruit gepolijst, lakcorrectie uitgevoerd en het interieur volledig gereinigd. De auto is weer als nieuw.',
    },
    {
      name: 'Freico Vinke',
      vehicle: 'Google review',
      rating: 5,
      text: 'Vakwerk geleverd door deze jongens. Ze hebben mijn Mercedes uit 1983 weer als nieuw laten shinen. Ook onze camper is vakkundig gepoetst. Mooi werk en zeker een aanrader.',
    },
  ],
};

export const BRANDS = [
  { name: 'Koch Chemie', tagline: 'Duitse chemie op wereldniveau' },
  { name: 'Gyeon', tagline: 'Premium keramische coatings' },
  { name: 'Gtechniq', tagline: 'Britse coating specialist' },
  { name: 'CarPro', tagline: 'Cquartz technologie' },
];

// Autobedrijven die met ons samenwerken
export const PARTNERS = [
  // sizeClass wordt per-logo afgestemd zodat alle merknamen (Dusseldorp, Leijenaar, Bergweide etc.)
  // op ongeveer dezelfde visuele hoogte uitkomen — belangrijk voor grid-consistentie.
  { name: 'Dusseldorp', brands: 'BMW · MINI', logo: '/partners/dusseldorp.png', sizeClass: 'max-h-24 md:max-h-28' },
  { name: 'Leijenaar', brands: 'Renault · Dacia', logo: '/partners/leijenaar.png', sizeClass: 'max-h-20 md:max-h-[104px]' },
  { name: 'De Croon', brands: 'Classic Cars & More', logo: '/partners/autobuitenhuis.jpg', sizeClass: 'max-h-24 md:max-h-28' },
  { name: 'Autobedrijf Bergweide', brands: 'Occasion specialist', logo: '/partners/bergweide.jpg', sizeClass: 'max-h-24 md:max-h-28' },
  { name: 'Cherokee4me', brands: 'Jeep Cherokee specialist', logo: '/partners/cherokee4me.png', sizeClass: 'max-h-16 md:max-h-20' },
];

export const TEAM = [
  {
    name: 'Mike Bakker',
    role: 'CEO & Oprichter',
    bio: '12+ jaar ervaring in automotive detailing. De perfectionist achter elke lakcorrectie.',
    image: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/tup20gtv_mike.png',
  },
  {
    name: 'Pim Fikenscher',
    role: 'CEO & Oprichter',
    bio: 'Verantwoordelijk voor de dagelijkse planning, klantcontact en kwaliteitscontrole. Werkt mee aan de detailing en zorgt ervoor dat iedere opdracht volgens hoge standaarden wordt uitgevoerd.',
    image: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/xldvvu3g_pim.jpeg',
  },
  {
    name: 'Tarique Vlijt',
    role: 'Senior Detailer',
    bio: 'Gespecialiseerd in interieur- en exterieurreiniging, showroomklaar afleveren en de afwerking van elk voertuig. Werkt nauwkeurig en met oog voor detail.',
    image: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/ix4db1hv_tarique.png',
  },
];

export const REVIEWS = [
  {
    name: 'Eva Smit',
    service: 'Ramentinten',
    rating: 5,
    text: 'Professioneel team, eerlijke prijs en het resultaat is werkelijk schitterend. Top service van A tot Z.',
  },
  {
    name: 'Mark de Jong',
    service: 'Auto Wrappen',
    rating: 5,
    text: 'Mat zwarte wrap op de Audi \u2014 strak afgewerkt, geen enkel detail vergeten. Echt aanrader.',
  },
  {
    name: 'Linda Visser',
    service: 'Lakcorrectie',
    rating: 5,
    text: 'Wat een verschil! De krassen in mijn zwarte BMW zijn volledig verdwenen. De lak heeft een diepte die ik nog nooit eerder gezien heb.',
  },
  {
    name: 'Jeroen Bakker',
    service: 'PPF',
    rating: 5,
    text: 'PPF-laag perfect aangebracht, geen enkele luchtbel. Communicatie top, planning op de minuut nauwkeurig.',
  },
  {
    name: 'Sophie van Dijk',
    service: 'Detailing',
    rating: 5,
    text: 'Mijn auto ziet er beter uit dan toen ik hem kocht. Echt vakmensen aan het werk.',
  },
  {
    name: 'Ruben Janssen',
    service: 'Glascoating',
    rating: 5,
    text: 'Diepe glans en water parelt eraf. Investering die zichzelf terugbetaalt.',
  },
];

export const PRICING = [
  {
    id: 'voordeel',
    label: 'Voordeel & Combinaties',
    intro: 'Deze combinaties worden het meest gekozen door onze klanten. Zo bespaar je tijd en profiteer je van een compleet resultaat voor een scherpe prijs.',
    items: [
      {
        title: 'Interieur + Exterieur Pakket',
        desc: 'Complete reiniging van interieur en exterieur voor een frisse uitstraling en verzorgde lak.',
        image: 'https://images.unsplash.com/photo-1708805282706-f44730b7e527?w=1200&q=80',
        suitableFor: ['Daily drivers die weer fris moeten voelen', 'Auto\u2019s v\u00f3\u00f3r inlevering of verkoop', 'Regelmatig onderhoud'],
        result: 'Een frisse, verzorgde auto van binnen en buiten \u2014 klaar voor gebruik.',
        bullets: [
          'Handwas van de carrosserie en velgen',
          'Basis lakreiniging en drogen',
          'Stofzuigen van interieur en vloermatten',
          'Dashboard en console schoonmaken',
          'Ramen en spiegels reinigen',
        ],
        time: '2\u20133 uur',
        price: 'Vanaf \u20ac175',
      },
      {
        title: 'Interieur + Exterieur Pakket + 1-Staps Polijstbeurt',
        desc: 'Complete interieur- en exterieurbehandeling inclusief lichte lakcorrectie voor een frisse en glanzende auto.',
        image: 'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1200&q=80',
        suitableFor: ['Auto\u2019s met oppervlakkige swirls', 'Wie een zichtbare glansverbetering wil', 'Auto\u2019s met matte plekken'],
        result: 'Diepere glans en herstelde lakhelderheid, met een compleet verzorgde auto.',
        bullets: [
          'Handwas van carrosserie en velgen',
          'Basis lakreiniging en drogen',
          'Stofzuigen van interieur, vloermatten en kofferbak',
          'Dashboard, console en deurpanelen schoonmaken',
          'Ramen en spiegels reinigen',
          'Lichte polijststap voor herstel van oppervlakkige swirls',
        ],
        time: '3\u20134 uur',
        price: 'Vanaf \u20ac275',
      },
      {
        title: 'Showroom Detail',
        desc: 'Complete detailbehandeling voor een ultieme afwerking, glans en showroomkwaliteit.',
        image: 'https://images.pexels.com/photos/94272/sports-car-pkw-auto-vehicle-94272.jpeg?auto=compress&cs=tinysrgb&w=1200',
        suitableFor: ['Concours & show cars', 'Auto\u2019s v\u00f3\u00f3r verkoop op topniveau', 'Exclusieve en klassieke voertuigen'],
        result: 'Showroomstaat \u2014 spiegelgladde lak, perfect interieur en langdurige bescherming.',
        bullets: [
          'Handwas en diepe reiniging van exterieur en velgen',
          'Grondige lakcorrectie (2\u20133 stappen, afhankelijk van lakconditie)',
          'Stofzuigen en diepe reiniging van interieur, vloermatten en kofferbak',
          'Dashboard, console, deurpanelen en overige oppervlakken reinigen',
          'Ramen en spiegels reinigen',
          'Afwerking met hoogwaardige wax of sealant',
        ],
        time: '6\u20138 uur',
        price: 'Vanaf \u20ac499',
      },
    ],
  },
  {
    id: 'exterieur',
    label: 'Exterieur',
    intro: '',
    items: [
      {
        title: 'Exterieur Reiniging',
        desc: 'Grondige en veilige handwas inclusief velgen, lakreiniging en drogen.',
        image: 'https://images.unsplash.com/photo-1601362840469-51e4d8d58785?w=1200&q=80',
        suitableFor: ['Wekelijks of maandelijks onderhoud', 'V\u00f3\u00f3r evenementen of fotoshoots', 'Auto\u2019s die vies zijn maar geen krassen hebben'],
        result: 'Schone, glanzende auto zonder waskrassen \u2014 klaar voor de weg.',
        time: '1\u20131,5 uur',
        price: 'Vanaf \u20ac95',
      },
      {
        title: 'Diepte Exterieur Reiniging',
        desc: 'Uitgebreide reiniging inclusief teer-, ijzer- en vuilverwijdering voor een optimale glans.',
        image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200&q=80',
        suitableFor: ['Auto\u2019s met vervuiling & aanslag', 'V\u00f3\u00f3r polijsten of coating', 'Na een zomer of winter met veel vuil'],
        result: 'Volledig gedecontamineerde lak \u2014 gladde afwerking en diepe glans.',
        time: '2\u20133 uur',
        price: 'Vanaf \u20ac150',
      },
      {
        title: 'Spotrepair',
        desc: 'Gerichte lakcorrectie voor kleine krassen en beschadigingen.',
        image: 'https://images.unsplash.com/photo-1613214450031-8d3d54d3d0d5?w=1200&q=80',
        suitableFor: ['Losse krassen op deur, bumper of motorkap', 'Winkelwagenkrassen', 'Lichte lakbeschadigingen'],
        result: 'Onzichtbaar verholpen kras \u2014 lokaal herstel zonder de hele auto te polijsten.',
        time: '1\u20132 uur',
        price: 'Vanaf \u20ac50',
      },
      {
        title: 'Koplampen Polijsten',
        desc: 'Herstel van doffe of vergeelde koplampen voor optimale lichtdoorlaatbaarheid.',
        image: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=1200&q=80',
        suitableFor: ['Oudere auto\u2019s met vergeelde koplampen', 'Auto\u2019s v\u00f3\u00f3r APK', 'Betere zichtbaarheid \u2019s nachts'],
        result: 'Kristalheldere koplampen \u2014 tot 90% meer lichtopbrengst en frissere uitstraling.',
        time: '0,5\u20131 uur',
        price: 'Vanaf \u20ac75',
      },
      {
        title: 'Motorruimte Reiniging',
        desc: 'Veilige en grondige reiniging voor een nette, verzorgde motorruimte.',
        image: 'https://images.unsplash.com/photo-1517524285303-d6fc683dddf8?w=1200&q=80',
        suitableFor: ['V\u00f3\u00f3r verkoop of taxatie', 'Liefhebbers die alles op orde willen', 'Onderhoud na lange rit'],
        result: 'Een verzorgde motorruimte die er als nieuw uitziet \u2014 tot in elke hoek.',
        time: '1\u20131,5 uur',
        price: 'Vanaf \u20ac75',
      },
      {
        title: 'Velgen Dieptereiniging',
        desc: 'Intensieve reiniging van velgen en remstof voor een glanzend resultaat.',
        image: 'https://images.unsplash.com/photo-1626843013254-51c46d3b3d29?w=1200&q=80',
        suitableFor: ['Auto\u2019s met hardnekkig remstof', 'V\u00f3\u00f3r velgcoating', 'Sportauto\u2019s met veel afzetting'],
        result: 'Als nieuwe velgen \u2014 diep gereinigd, glanzend en klaar voor bescherming.',
        time: '0,5\u20131 uur',
        price: 'Vanaf \u20ac65',
      },
      {
        title: 'Lakbescherming (Wax / Sealant)',
        desc: 'Bescherming en extra glans voor de lak, voor langdurige verzorging.',
        image: 'https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=1200&q=80',
        suitableFor: ['Auto\u2019s zonder coating', 'Tussentijdse bescherming', 'Wie extra glans wil'],
        result: 'Water parelt eraf en de auto blijft langer schoon \u2014 met een diepe glans.',
        time: '1\u20132 uur',
        price: '\u20ac25 \u2013 \u20ac50',
      },
      {
        title: 'Keramische Coating',
        desc: 'Hoogwaardige coating voor langdurige bescherming en diepe glans.',
        image: 'https://images.unsplash.com/photo-1449426468159-d96dbf08f19f?w=1200&q=80',
        suitableFor: ['Nieuwe auto\u2019s', 'Liefhebbersauto\u2019s', 'Auto\u2019s die makkelijker schoon moeten blijven'],
        result: 'Jarenlange bescherming, extreme hydrofobiciteit en showroom-glans.',
        bullets: ['3PH wassen auto', '1 gratis onderhoudswasbeurt gedurende looptijd', 'Gratis onderhoudspakket', 'Certificaat'],
        time: '24 uur',
        price: 'Vanaf \u20ac795',
      },
    ],
  },
  {
    id: 'interieur',
    label: 'Interieur',
    intro: '',
    items: [
      {
        title: 'Interieur Reiniging',
        desc: 'Volledige basisreiniging van het interieur voor een frisse uitstraling.',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200&q=80',
        suitableFor: ['Regulier onderhoud', 'Gezinsauto\u2019s', 'Auto\u2019s v\u00f3\u00f3r een verre reis'],
        result: 'Een frisse, opgeruimde binnenkant \u2014 comfort en stijl elke rit.',
        time: '1\u20132 uur',
        price: 'Vanaf \u20ac110',
      },
      {
        title: 'Diepte Interieur Reiniging',
        desc: 'Grondige reiniging inclusief bekleding en vlekverwijdering.',
        image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200&q=80',
        suitableFor: ['Auto\u2019s met vlekken en aanslag', 'Bedrijfsauto\u2019s', 'V\u00f3\u00f3r verkoop of inlevering'],
        result: 'Als nieuw interieur \u2014 vlekvrij, geurloos en volledig verzorgd.',
        time: '2\u20133 uur',
        price: 'Vanaf \u20ac175',
      },
      {
        title: 'Stoel Reiniging',
        desc: 'Dieptereiniging van stoffen of leren stoelen voor optimale frisheid.',
        image: 'https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=1200&q=80',
        suitableFor: ['Vlekken door voedsel of drank', 'Gezinsauto\u2019s met jonge kinderen', 'Rokersauto\u2019s'],
        result: 'Perfect gereinigde stoelen \u2014 fris en zonder vlekken.',
        time: '1\u20132 uur',
        price: 'Vanaf \u20ac50',
      },
      {
        title: 'Hemel Reiniging',
        desc: 'Voorzichtige reiniging van de dakhemel voor een volledig verzorgd interieur.',
        image: 'https://images.unsplash.com/photo-1618761714954-0b8cd0026356?w=1200&q=80',
        suitableFor: ['Rokersauto\u2019s', 'Auto\u2019s met vlekken op de hemel', 'Volledig detailonderhoud'],
        result: 'Frisse, vlekvrije dakhemel zonder loslatende bekleding.',
        time: '1 uur',
        price: 'Vanaf \u20ac65',
      },
      {
        title: 'Leer Reiniging & Behandeling',
        desc: 'Reiniging en voeding van leren bekleding voor langdurige zachtheid en bescherming.',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200&q=80',
        suitableFor: ['Auto\u2019s met leren bekleding', 'Preventief onderhoud', 'Herstel van uitgedroogd leer'],
        result: 'Zacht, verzorgd en beschermd leer \u2014 als nieuw.',
        time: '1\u20132 uur',
        price: 'Vanaf \u20ac99',
      },
      {
        title: 'Geurbehandeling',
        desc: 'Verwijderen van ongewenste geuren en opfrissen van het interieur.',
        image: 'https://images.unsplash.com/photo-1620584899131-a5ff5f8fbb03?w=1200&q=80',
        suitableFor: ['Rokersauto\u2019s', 'Huisdieren-geuren', 'Auto\u2019s na langdurig gebruik'],
        result: 'Volledig neutraal, fris interieur \u2014 geen chemische parfums, alleen frisheid.',
        time: '0,5\u20131 uur',
        price: 'Vanaf \u20ac45',
      },
    ],
  },
  {
    id: 'lakcorrectie',
    label: 'Lakcorrectie & Detailing',
    intro: '',
    items: [
      {
        title: '1-Staps Polijstbeurt',
        desc: 'Lichte lakcorrectie voor het verwijderen van oppervlakkige swirls en doffe plekken. Geeft een mooie glans aan de lak.',
        image: 'https://images.unsplash.com/photo-1607860108855-64acf2078ed9?w=1200&q=80',
        suitableFor: ['Auto\u2019s met lichte swirls', 'Zichtbare glansverbetering gewenst', 'V\u00f3\u00f3r een sealant of wax'],
        result: 'Duidelijk zichtbare glansverbetering en helderder gekleurde lak.',
        time: '2\u20133 uur',
        price: 'Vanaf \u20ac190',
      },
      {
        title: '2-Staps Polijstbeurt',
        desc: 'Diepere lakcorrectie om zichtbare krassen en doffe plekken te verwijderen. Voor een gladdere en glanzendere lakfinish.',
        image: 'https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=1200&q=80',
        suitableFor: ['Auto\u2019s met zichtbare krassen', 'V\u00f3\u00f3r een keramische coating', 'Liefhebbers die diepere glans willen'],
        result: 'Krassen verwijderd, diepe glans hersteld \u2014 richting showroomstaat.',
        time: '4\u20135 uur',
        price: 'Vanaf \u20ac340',
      },
      {
        title: '3-Staps Polijstbeurt',
        desc: 'Maximale lakcorrectie inclusief schuren van de lak voor een spiegelgladde, showroomwaardige finish. Verwijdert diepe krassen, hologrammen en doffe plekken volledig.',
        image: 'https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=1200&q=80',
        suitableFor: ['Concours en show cars', 'Exclusieve voertuigen', 'Auto\u2019s met zware lakschade'],
        result: 'Spiegelgladde, foutloze lak \u2014 het maximaal haalbare op uw voertuig.',
        time: '6\u20138 uur',
        price: 'Vanaf \u20ac495',
      },
      {
        title: 'Showroom Detail',
        desc: 'Complete detailbehandeling voor een ultieme afwerking en glans. Interieur en exterieur worden perfect verzorgd.',
        image: 'https://images.unsplash.com/photo-1611821064430-0d40291d0f0b?w=1200&q=80',
        suitableFor: ['V\u00f3\u00f3r verkoop op topniveau', 'Concours d\u2019Elegance', 'Exclusieve voertuigen'],
        result: 'Volledige showroomstaat \u2014 uw auto voelt en ziet er letterlijk nieuw uit.',
        time: '5\u20136 uur',
        price: 'Vanaf \u20ac499',
      },
      {
        title: 'Nieuwstaat Detail (New Car Detail)',
        desc: 'Bescherming en voorbereiding van nieuwe voertuigen, zoals showroomnieuw. Inclusief lak, interieur en glasbehandeling.',
        image: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=1200&q=80',
        suitableFor: ['Zojuist opgehaalde nieuwe auto\u2019s', 'Auto\u2019s v\u00f3\u00f3r keramische coating', 'Bescherming vanaf dag 1'],
        result: 'Perfect voorbereide nieuwwaarde \u2014 klaar voor bescherming die jaren meegaat.',
        time: '4\u20135 uur',
        price: 'Vanaf \u20ac300',
      },
    ],
  },
];

export const PORTFOLIO_CATEGORIES = [
  { id: 'all', label: 'Alle projecten' },
  { id: 'exclusief', label: "Exclusieve auto's" },
  { id: 'oldtimer', label: 'Oldtimers' },
  { id: 'camper', label: 'Campers' },
  { id: 'vrachtwagen', label: 'Vrachtwagens' },
  { id: 'motor', label: 'Motoren' },
];

// Note: Instagram-integratie voor shiny.cleaning.nl is niet mogelijk zonder
// business API. Onderstaande beeldselectie is representatief (Unsplash/Pexels).
export const PORTFOLIO_PROJECTS = [
  {
    id: 'bmw-i5-m60',
    category: 'exclusief',
    featured: true,
    title: 'BMW i5 M60',
    subtitle: 'Elektrische kracht, beschermd met matte lakverzegeling',
    badge: 'Matte lakverzegeling',
    video: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/frdnexul_1784803466106.mov',
    treatments: ['Matte lakverzegeling', 'Exterieur reiniging', 'Interieur reiniging', 'Leerbehandeling'],
    before: 'https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=1400&q=80',
    after: 'https://images.unsplash.com/photo-1617531653332-bd46c24f2068?w=1400&q=80',
  },
  {
    id: 'porsche-macan-s',
    category: 'exclusief',
    featured: true,
    title: 'Porsche Macan S',
    subtitle: 'Diepe glans na 2-staps polijstbeurt',
    badge: '2-staps polijstbeurt',
    video: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/ai9kwkn2_1784799782336.mov',
    treatments: ['2-staps polijstbeurt', 'Exterieur reiniging', 'Interieur reiniging', 'Leerbehandeling'],
    before: 'https://images.pexels.com/photos/1592384/pexels-photo-1592384.jpeg?auto=compress&cs=tinysrgb&w=1400',
    after: 'https://images.pexels.com/photos/210019/pexels-photo-210019.jpeg?auto=compress&cs=tinysrgb&w=1400',
  },
  {
    id: 'range-rover',
    category: 'exclusief',
    featured: true,
    title: 'Range Rover Sport',
    subtitle: 'Britse allure hersteld tot topconditie',
    badge: '2-staps polijstbeurt',
    video: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/jqi4efsf_1784800006799.mov',
    treatments: ['2-staps polijstbeurt', 'Exterieur reiniging', 'Interieur reiniging', 'Leerbehandeling'],
    before: 'https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=1400&q=80',
    after: 'https://images.unsplash.com/photo-1533473359331-0135ef1b58bf?w=1400&q=80',
  },
  {
    id: 'lancia-beta-monte-carlo',
    category: 'oldtimer',
    featured: true,
    title: 'Lancia Beta Monte Carlo (1976)',
    subtitle: 'Italiaanse klassieker teruggebracht naar showroomstaat',
    badge: 'Keramische coating',
    video: 'https://customer-assets-jt897jd0.emergentagent.net/job_shiny-clone/artifacts/s1xoo9zy_1784799954985.mov',
    treatments: ['3-staps polijstbeurt', 'Lakcorrectie', 'Keramische coating', 'Detailing afwerking'],
    before: 'https://images.pexels.com/photos/1035108/pexels-photo-1035108.jpeg?auto=compress&cs=tinysrgb&w=1400',
    after: 'https://images.pexels.com/photos/337909/pexels-photo-337909.jpeg?auto=compress&cs=tinysrgb&w=1400',
  },
];

export const BOOKING_CATEGORIES = [
  {
    id: 'populair',
    label: 'Meest Gekozen',
    sub: 'Onze populairste behandelingen',
    count: 3,
    options: ['Premium Detailing Pakket', 'Glascoating 5-jaar', 'PPF Front Pakket'],
  },
  {
    id: 'exterieur',
    label: 'Exterieur Detailing',
    sub: 'Behandelingen voor buitenkant',
    count: 6,
    options: ['Handwas Premium', 'Wax behandeling', 'Velgen reiniging', 'Decontaminatie', 'Sealant', 'Hydrofobe coating'],
  },
  {
    id: 'interieur',
    label: 'Interieur Detailing',
    sub: 'Behandelingen voor binnenkant',
    count: 6,
    options: ['Stoffering reiniging', 'Lederbehandeling', 'Dashboard detail', 'Hemel reinigen', 'Geur neutralisatie', 'Diepe stofzuig'],
  },
  {
    id: 'lakcorrectie',
    label: 'Lakcorrectie',
    sub: 'Krassen, swirls en defecten verwijderen',
    count: 3,
    options: ['1-staps polish', '2-staps polish', '3-staps show finish'],
  },
  {
    id: 'abonnement',
    label: 'Abonnement',
    sub: 'Maandelijks onderhoud',
    count: 3,
    options: ['Basic maandwas', 'Plus maandwas + interieur', 'Premium full service'],
  },
];
